(function () {
  function init() {
    var root = document.querySelector('[data-ttf-gallery]');
    if (!root || root.__ttfReady) return;
    var track = root.querySelector('[data-ttf-main]');
    if (!track) return;
    root.__ttfReady = true;

    var slides = Array.prototype.slice.call(track.querySelectorAll('.ttf-gallery__slide'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.ttf-gallery__thumb'));
    var dots   = Array.prototype.slice.call(root.querySelectorAll('.ttf-gallery__dot'));
    var lb     = document.querySelector('[data-ttf-lightbox]');
    var lbImg  = lb ? lb.querySelector('img') : null;

    function setActive(i) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function goTo(i) {
      var s = slides[i];
      if (!s) return;
      s.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'smooth' });
      setActive(i);
    }
    function goToMedia(id) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(id)) { goTo(i); return; }
      }
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-index'), 10)); });
    });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-index'), 10)); });
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio >= .6) {
            setActive(parseInt(e.target.getAttribute('data-index'), 10));
          }
        });
      }, { root: track, threshold: [.6] });
      slides.forEach(function (s) { io.observe(s); });
    }

    if (lb && lbImg) {
      track.addEventListener('click', function (e) {
        var img = e.target.closest('.ttf-gallery__slide img[data-zoom]');
        if (!img) return;
        lbImg.src = img.getAttribute('data-zoom');
        lb.hidden = false;
        document.body.style.overflow = 'hidden';
      });
      var closeLb = function () { lb.hidden = true; lbImg.src = ''; document.body.style.overflow = ''; };
      lb.addEventListener('click', closeLb);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) closeLb(); });
    }

    var jsonEl = document.querySelector('.product-json');
    var variants = [];
    try { variants = JSON.parse(jsonEl.textContent).variants || []; } catch (err) {}
    document.addEventListener('change', function (e) {
      var form = e.target.closest && e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      setTimeout(function () {
        var idEl = form.querySelector('[name="id"]');
        if (!idEl) return;
        var v = variants.filter(function (q) { return String(q.id) === String(idEl.value); })[0];
        if (v && v.featured_media) goToMedia(v.featured_media.id);
      }, 50);
    });
  }

  function boot() {
    init();
    new MutationObserver(function () { init(); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();